import { useChartContext } from '../core/chart-context';

export interface HoverBandsProps {
  /** Called with the hovered x-slot index, or null on leave */
  onHover: (index: number | null, position: { x: number; y: number }) => void;
  /** Highlights the hovered band background */
  highlight?: boolean;
  activeIndex?: number | null;
}

/** Invisible full-height bands so hovering anywhere on a column triggers the tooltip. */
export const HoverBands = ({ onHover, highlight, activeIndex }: HoverBandsProps) => {
  const { xScale, dimensions } = useChartContext();
  const { domain, step } = xScale;

  return (
    <g data-slot='chart-hover-bands'>
      {domain.map((x, index) => {
        const center = xScale.position(x);
        const left = center - step / 2;

        return (
          <rect
            key={`${index}-${x}`}
            data-slot='chart-hover-band'
            data-x={x}
            x={left}
            y={0}
            width={step}
            height={dimensions.innerHeight}
            fill={
              highlight && activeIndex === index ? 'var(--color-background-muted)' : 'transparent'
            }
            onPointerEnter={() => onHover(index, { x: center, y: 0 })}
            onPointerMove={event =>
              onHover(index, {
                x: center,
                y: event.nativeEvent.offsetY - dimensions.margin.top
              })
            }
            onPointerLeave={() => onHover(null, { x: 0, y: 0 })}
          />
        );
      })}
    </g>
  );
};

HoverBands.displayName = 'HoverBands';
